enum WarehouseIdValue {
  BLACK_CAT = 1,
  BLUE_SPARROW = 2,
}

export const warehouseIdMap = {
  [WarehouseIdValue.BLACK_CAT]: "黑貓",
  [WarehouseIdValue.BLUE_SPARROW]: "藍雀",
};

export default WarehouseIdValue;
